import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'app/config.const';
import { Agenda, IAgenda } from 'app/model/agenda';
import { CFID } from 'app/model/id';
import { RESTArray } from '../angular-rest';

@Injectable()
export class Agende extends RESTArray<Agenda, IAgenda, CFID> {
	constructor($http: HttpClient) {
		super(
			$http,
			`${Config.baseURL}/agende`,
			(h, u, r) => new Agenda(h, u, r),
			({ codice_fiscale, nome }) => ({ codice_fiscale, nome }),
			(id) => `${id.codice_fiscale}/${id.nome}`
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/model/agende.ts